import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FormControl } from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ServerUrlService } from 'src/app/services/server-url.service';

interface Response extends Array<any> {}

@Component({
  selector: 'app-troca-senha',
  templateUrl: './troca-senha.component.html',
  styleUrls: ['./troca-senha.component.scss']
})
export class TrocaSenhaComponent implements OnInit {
  codigo: string;
  erro: string;
  email: string;
  senha: string;
  senhaConf: string;
  smallScreen: boolean;
  codigoControl = new FormControl();
  emailControl = new FormControl();

  constructor(
    private authService: AuthService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private snackBar: MatSnackBar,
    private serverUrlService: ServerUrlService
  ) {
    breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(result => {
      this.smallScreen = result.matches;
    });
   }

  ngOnInit() {
  }

  onEnviarCodigoClick() {
    const { codigo, email, senha } = this;

    if (codigo && email && this.senhaStatus() === 'igual') {
      this.erro = null;
      const query = { codigo, email, senha };
      this.authService.enviaCodigoRecuperacao(query)
        .subscribe((response: Response[any]) => {

          this.codigoControl.setErrors(null);
          this.emailControl.setErrors(null);

          if (response && response.confirmation === 'success') {
            this.router.navigate(['/' + this.serverUrlService.getName() +'/client/agendamento']);
          } else {
            // this.erro = 'Código e/ou email não conferem.';
            this.snackBar.open('Código e/ou email não conferem.', '', {duration: 5000});
            this.codigoControl.setErrors({incorrect: true});
            this.emailControl.setErrors({incorrect: true});
          }
        },
        err => {
          /*window.alert(
            'Erro na solicitação, favor checar internet ou tentar novamente em alguns minutos.'
          );*/
          this.snackBar.open('Erro na solicitação, favor checar internet ou tentar novamente em alguns minutos.', '', {duration: 5000});
        }
      );
    } else {
      // this.erro = 'Favor preencher todos os campos e conferir senha.';
      this.snackBar.open('Favor preencher todos os campos e conferir senha.', '', {duration: 5000});
    }
  }

  senhaStatus() {
    const { senha, senhaConf } = this;
    if (senha && senhaConf) {
      if (senha === senhaConf) { return 'igual'; }
      return 'dif';
    }
    return 'vazio';
  }

  validaFormulario() {
    let valido = true;
    if (!this.codigo) {
      valido = false;
    }
    if (!this.email) {
      valido = false;
    }
    if (!this.senhaConf || !this.senha) {
      valido = false;
    }
    if (this.senhaStatus() === 'dif') {
      valido = false;
    }
    return valido;
  }

  limparErrors() {
    this.codigoControl.setErrors(null);
    this.emailControl.setErrors(null);
  }
}
